var text_field_default = {
  "root": "_0S6LU",
  "text": "d4YwJ",
  "input": "FBICl",
  "small": "_5xXuC",
  "medium": "NHqrn",
  "large": "meOx6",
  "webview": "ii1tb",
  "endAdornment": "UR7E-",
  "shown": "livNR",
  "value": "_2NYoh",
  "spinner": "TjFrC",
  "spin": "_3mYTE"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
